export default __webpack_public_path__ + "static/media/banner_point_loyalty.1a15561e.png";